import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const MyDialog = (props) => {

    return (
        <Dialog
            open={props.open}
            onClose={props.onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{"同意情報を更新しますか？"}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    ゲノム情報プラットフォームへのデータ連携有無が更新されます。
              </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose} color="primary">
                    いいえ
                  </Button>
                <Button onClick={props.handleClickYes} color="primary" autoFocus>
                    はい
                  </Button>
            </DialogActions>
        </Dialog>
    );
}

export default MyDialog;